import { useReactiveVar } from "@apollo/client";
import React from "react";
import { useTranslation } from "react-i18next";

import { isVerificationToastShowVar } from "../../graphql/globalVar/state";
import VerificationSentToast from "../../pages/profilePage/components/verificationSentToast";

import AccessModal from "./access";
import ArchiveModal from "./archive";
import AttetionModal from "./attetion";
import CreateCopyModal from "./createCopy";
import EmailVerifyCreateEventModal from "./emailVerifyCreateEvent";
import EventStatusModal from "./eventStatus";
import NotificationVerifyEmailModal from "./notificationVerifyEmail";
import RevokeAccessModal from "./revokeAccess";
import ShareEventModal from "./shareEvent";
import StopTicketsSaleModal from "./stopTicketsSale";
import UnlockWhiteLabelModal from "./unlockWhiteLabel";
import WhiteLabelLimitModal from "./whiteLabelLimit";

export default function GlobalModals() {
  const { t } = useTranslation();
  const isVerificationToastShow = useReactiveVar(isVerificationToastShowVar);

  return (
    <>
      <AccessModal />
      <ArchiveModal />
      <AttetionModal />
      <CreateCopyModal />
      <EmailVerifyCreateEventModal />
      <EventStatusModal />
      <ShareEventModal />
      <StopTicketsSaleModal />
      <WhiteLabelLimitModal />
      <UnlockWhiteLabelModal />
      <NotificationVerifyEmailModal />
      <RevokeAccessModal />
      <VerificationSentToast
        isShow={isVerificationToastShow}
        handleClose={() => isVerificationToastShowVar(false)}
        message={t("profile.verificationSent")}
      />
    </>
  );
}
